// Les états vides qui guident (D-091, maquette c2) : une liste vide dit ce qu'on y fera, en une
// phrase, avec « Montre-moi » (la visite, data-tour : src/guide/index.ts) et un second geste.
import { html, type Html } from '../ui/dom';

/** Dessins des états vides : un terrain (plays), sinon une icône de l'app. */
const COURT = html`<svg class="gd-court" viewBox="0 0 120 84" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
  <rect x="6" y="4" width="108" height="76" rx="3"/><path d="M38 4v30h44V4M44 34a16 16 0 0 0 32 0"/><circle cx="60" cy="10" r="2.5"/>
  <circle cx="34" cy="56" r="5" class="gd-dot" stroke="none"/><circle cx="84" cy="50" r="5" class="gd-dot" stroke="none"/><path d="M38 54c14-8 26-8 40-4" stroke-dasharray="4 4"/></svg>`;

export interface EmptyGuide {
  /** 'court' (plays), ou une icône de l'app (ti-cal, ti-id…). */
  art: 'court' | string;
  title: string;
  text: string;
  /** La visite « Montre-moi ». */
  tour?: string;
  /** Le second geste : un lien, ou un bouton de l'écran (id). */
  alt?: { label: string; href?: string; id?: string };
  foot?: string;
  guide?: string;
}

export function emptyGuide(e: EmptyGuide): Html {
  return html`
    <section class="gd-empty" data-guide="${e.guide ?? 'empty'}">
      ${e.art === 'court' ? COURT : html`<span class="gd-empty-ico" aria-hidden="true"><span class="ti ${e.art}"></span></span>`}
      <h3>${e.title}</h3>
      <p>${e.text}</p>
      ${e.tour || e.alt ? html`<div class="btn-row">
        ${e.tour ? html`<button type="button" class="btn btn-primary gd-show" data-tour="${e.tour}">Montre-moi</button>` : ''}
        ${e.alt ? (e.alt.href ? html`<a class="btn btn-ghost" href="${e.alt.href}">${e.alt.label}</a>` : html`<button type="button" class="btn btn-ghost" id="${e.alt.id ?? ''}">${e.alt.label}</button>`) : ''}
      </div>` : ''}
      ${e.foot ? html`<small class="muted">${e.foot}</small>` : ''}
    </section>`;
}
